"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _getIterator2 = _interopRequireDefault(require("@babel/runtime/core-js/get-iterator"));

var _promise = _interopRequireDefault(require("@babel/runtime/core-js/promise"));

exports.registerServiceWorker = function () {
  return true;
};

var swNotInstalled = true;
var pathnameResources = [];

exports.onPrefetchPathname = function (_ref) {
  var pathname = _ref.pathname,
      getResourcesForPathname = _ref.getResourcesForPathname;

  // if SW is not installed, we need to record any prefetches
  // that happen so we can then add them to SW cache once installed
  if (swNotInstalled && "serviceWorker" in navigator) {
    pathnameResources.push(new _promise.default(function (resolve) {
      getResourcesForPathname(pathname).then(function (resources) {
        resolve(resources);
      });
    }));
  }
};

exports.onServiceWorkerInstalled = function () {
  // stop recording prefetch events
  swNotInstalled = false; // grab nodes from head of document

  var nodes = document.querySelectorAll("\n    head > script[src],\n    head > link[as=script],\n    head > link[rel=stylesheet],\n    head > style[data-href]\n  "); // get all resource URLs

  var resources = [].slice.call(nodes).map(function (node) {
    return node.src || node.href || node.getAttribute("data-href");
  });

  for (var _iterator = resources, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator2.default)(_iterator);;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var resource = _ref2;
    fetch(resource);
  } // loop over all resources and fetch the page component and JSON
  // thereby storing it in SW cache


  _promise.default.all(pathnameResources).then(function (pageResources) {
    for (var _iterator2 = pageResources, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator2.default)(_iterator2);;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var pageResource = _ref3;
      if (pageResource) fetch(pageResource.page.jsonURL);
    }
  });
};